module.exports = __webpack_public_path__ + "static/img/zamooza.5a51fafd.png";